import { BrandLogoEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandLogoUseVO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandLogoUseVO.validationSchema(),
    BrandLogoEntity
  );

  constructor(readonly value: RoomBrandLogoUse) {
    JsonSchemaValidator.assert(RoomBrandLogoUseVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandLogo"],
      properties: {
        roomId,
        brandLogo: {
          instanceof: BrandLogoEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandLogoUse {
  roomId: RoomId;
  brandLogo: BrandLogoEntity;
}
